module.exports = __webpack_public_path__ + "assets/img/18_1864_big.9adde93c.jpg";